import PropTypes from 'prop-types';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { v4 as uuidv4 } from 'uuid';

import RichText from '../RichText';
import CtaTextLink from '../CtaTextLink';
import FaqBreadcrumb from '../FaqBreadcrumb';
import FaqRelatedQuestionsSection from '../FaqRelatedQuestionsSection';
import FaqSearch from '../FaqSearch';

import {
  PageStyles,
  Section,
  Container,
  CategoryFaqs,
  Heading,
  Description,
} from './styles';

const heading = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <h1>{children}</h1>,
    [BLOCKS.HEADING_1]: (_, children) => <h1>{children}</h1>,
    [BLOCKS.HEADING_2]: (_, children) => <h1>{children}</h1>,
    [BLOCKS.HEADING_3]: (_, children) => <h1>{children}</h1>,
    [BLOCKS.HEADING_4]: (_, children) => <h1>{children}</h1>,
    [BLOCKS.HEADING_5]: (_, children) => <h1>{children}</h1>,
    [BLOCKS.HEADING_6]: (_, children) => <h1>{children}</h1>,
  },
};

const FaqCategoryAnswersLanding = ({
  categoryData,
  subCategoryData,
  faqData,
  data,
  search,
  themes,
}) => {
  if (!data) return null;

  const linkRawOptions = {
    renderNode: {
      [INLINES.HYPERLINK]: (node, children) => {
        const {
          data: { uri },
        } = node;
        return (
          <CtaTextLink
            key={`${uuidv4()}-${uri}`}
            url={uri}
            inline
            className="content"
            themes={themes}
          >
            {children}
          </CtaTextLink>
        );
      },
    },
  };

  return (
    <>
      <PageStyles themes={themes}>
        <FaqBreadcrumb
          category={categoryData.faqCategoryName}
          themes={themes}
        />
        <FaqSearch data={search} themes={themes} />
      </PageStyles>
      <Section>
        <Container>
          <CategoryFaqs themes={themes}>
            <Heading>
              <RichText document={faqData.question} options={heading} />
            </Heading>
            <Description>
              <RichText document={faqData.answer} options={linkRawOptions} />
            </Description>
          </CategoryFaqs>
        </Container>
      </Section>
      <FaqRelatedQuestionsSection data={subCategoryData} themes={themes} />
    </>
  );
};

FaqCategoryAnswersLanding.propTypes = {
  data: PropTypes.shape().isRequired,
  search: PropTypes.shape().isRequired,
  categoryData: PropTypes.shape().isRequired,
  subCategoryData: PropTypes.shape().isRequired,
  faqData: PropTypes.shape().isRequired,
  themes: PropTypes.string.isRequired,
};

FaqCategoryAnswersLanding.defaultProps = {};

export default FaqCategoryAnswersLanding;
